import Button from "@app/sharedComponents/Button/Button";
import { ThemedText, ThemedView } from "@app/theme";

const WhyOpenAcc = ({ closeBottomSheet }: { closeBottomSheet: () => void }) => {
    return (
        <ThemedView p="lg">
            <ThemedText variant="h4s" color="text-primary" >Why open a new loan account?</ThemedText>
            <ThemedText mt="xs" variant="b3r" color="text-secondary" mb="4xl">
                Volt Money has partnered with DSP Finance, part of DSP Group to facilitate loan against mutual funds.
            </ThemedText>
            <ThemedText variant="b3r" color="text-secondary" mb="lg">
                The new loan provides you a host of benefits like 24/7 withdrawals, instant pledging and un-pledging of collaterals. All of this backed by priority support from Volt Money.
            </ThemedText>
            <Button label="Ok, got it!" size="MD" handlePress={closeBottomSheet} />
        </ThemedView>
    )
}

export default WhyOpenAcc;